import { Component } from '@angular/core';

@Component({
  selector: 'app-service-validation',
  templateUrl: './service-validation.component.html',
  styleUrls: ['./service-validation.component.css'],
})
export class ServiceValidationComponent {
  title1 = 'Admin Panel';
  title = 'Service Validation';
  class1 = 'profile-banner ';
  img1 = '../../../assets/images/logo.png';
}
